import React, { Component } from 'react';
import './CSS/Footer.css';

import Pointer from '../Assets/pointer.png';

export class Footer extends Component {
    render() {
        return (
            <div className='footer'>
                <span><img className='footer-map-marker' src={Pointer} alt='Marker' /></span>
                <span>
                    Av. República do Líbano, 251, Rio Mar Trade Center - Torre 4, Salas 316/318 — Boa Viagem — Recife/PE — 51116-160.<br/>
                    Contate-nos: +55 (81) 3038-9496 | <i className='fa fa-whatsapp footer-wpp' /> +55 (81) 99393-1527 | atendimento@joriovalenca.com.br
                </span>
            </div>
        )
    }
}

export default Footer;
